import styled from "styled-components";

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AddIconContainer = styled.div`
  margin-left: 16px;
  &:hover {
    cursor: pointer;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  gap: 32px;
  align-items: center;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    flex-direction: column;
    align-items: start;
    >div {
      &:nth-child(1) {
        grid-area: title;
      }

      &:nth-child(2) {
        grid-area: input-one;
      }

      &:nth-child(3) {
        grid-area: input-two;
      }
    }
  }
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(100px, 1fr) );
  align-items: center;
  margin-bottom: 32px;
  width: 100%;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    gap: 16px;
    margin-bottom: 0px;
    grid-template-areas: 
    "title title"
    "input-one input-two";

    >div {
      &:nth-child(1) {
        grid-area: title;
      }

      &:nth-child(2) {
        grid-area: input-one;
      }

      &:nth-child(3) {
        grid-area: input-two;
      }
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 8px;
`;